import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown, faSearch } from '@fortawesome/pro-regular-svg-icons';
import './NewCircleModalIntro.scss';

import { getCuratorGroups } from '../../../../Helpers/user_helpers';
import SmartImage from '../../../General/SmartImage';
const NewCircleModalIntro = props => {
  const { selectedCurators } = props;
  const [activeFaqIdx, setActiveFaqIdx] = React.useState(null);
  const toggleFaq = idx => setActiveFaqIdx(idx === activeFaqIdx ? null : idx);
  const faq = [
    {
      question: 'What is a Circle?',
      answer:
        "A Circle is your own curated storefront. You choose the creators you trust, and we automatically pull in the products they recommend—organized into a clean storefront with a 'Latest Finds' tab showing what’s new."
    },
    {
      question: 'Why would I want to make one?',
      answer:
        'It lets you organize your shopping experience around the people whose taste you trust. Instead of trying to keep up with product links across social media, everything they recommend lives in one place.'
    },
    {
      question: 'How does it work?',
      answer:
        'You add curators to your Circle. As they share product links, your shop updates automatically. You can create as many Circles as you want—by theme, by mood, or however you like to shop.'
    }
  ].map((faq, idx) => ({ ...faq, isActive: idx === activeFaqIdx }));
  const hasCuratorGroups = getCuratorGroups(props.user).length > 0;
  return (
    <div className='new-circle-modal-intro-container'>
      <div className='new-circle-modal-intro-content'>
        <SmartImage src='http://static.shopmy.us/Create+Circle+Example.png' growIn alt='Circle Example' />
      </div>
      <div className='title-container'>
        <div className='title'>{hasCuratorGroups ? 'Create a new circle' : 'Create your first circle'}</div>
        <div className='description'>Curate your own group of people to aid you in discovering things you'll love.</div>
        <div className='action-btns'>
          <div className='action-btn search' onClick={props.pressToSearch}>
            <FontAwesomeIcon icon={faSearch} />
            Search
          </div>
          <div className='action-btn primary' onClick={props.goToNextPanel}>
            {selectedCurators.length ? 'Discover More' : hasCuratorGroups ? 'Get Started' : 'Get Started'}
          </div>
        </div>
      </div>
      <div className='faq-container'>
        {faq.map((faq, idx) => {
          const { question, answer, isActive } = faq;
          const toggle = () => toggleFaq(idx);
          return (
            <div className='faq-item' key={faq.idx}>
              <div className='faq-question-container' onClick={toggle}>
                <div className='faq-question'>{question}</div>
                <div className='faq-question-icon'>
                  {isActive ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                </div>
              </div>
              {isActive && <div className='faq-answer'>{answer}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
};

NewCircleModalIntro.propTypes = {
  user: PropTypes.object.isRequired,
  goToNextPanel: PropTypes.func.isRequired,
  pressToSearch: PropTypes.func.isRequired,
  selectedCurators: PropTypes.array.isRequired
};

export default NewCircleModalIntro;
